import { render, staticRenderFns } from "./BudgetPlan.vue?vue&type=template&id=cc20fed8&scoped=true&"
import script from "./BudgetPlan.vue?vue&type=script&lang=js&"
export * from "./BudgetPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc20fed8",
  null
  
)

export default component.exports